import * as bus from "@sinch/bus";
import {
  flagsConfigChangedListener,
  getFeatureFlag,
} from "@sinch/feature-flags";
import { useCallback, useEffect, useState } from "react";
import type { ShellUser } from "../api/types";
import {
  getBrowserLang,
  matchLocaleToSupported,
  setWindowIntlMeta,
} from "./intl.utils";

export const useSyncLocale = ({ user }: { user?: ShellUser | undefined }) => {
  const [browserLangEnabled, setBrowserLangEnabled] = useState(
    getFeatureFlag(
      "useBrowserLanguage",
      (x): x is boolean => typeof x === "boolean",
      true
    )
  );
  const getLocale = useCallback(
    () => matchLocaleToSupported(user?.language || getBrowserLang()),
    [user?.language]
  );
  const [locale, setLocale] = useState(getLocale);

  useEffect(() => {
    setWindowIntlMeta(locale);
    bus.sendGlobal(bus.intlChangedMessage());
  }, [locale]);

  useEffect(
    () =>
      flagsConfigChangedListener(() => {
        const newFlagValue = getFeatureFlag(
          "useBrowserLanguage",
          (x): x is boolean => typeof x === "boolean",
          true
        );

        if (browserLangEnabled !== newFlagValue) {
          setBrowserLangEnabled(newFlagValue);

          const newLocale = getLocale();

          if (newLocale !== locale) {
            setLocale(newLocale);
          }
        }
      }),
    [user, locale, browserLangEnabled, getLocale]
  );

  return locale;
};
